import { render, staticRenderFns } from "./TabJob.vue?vue&type=template&id=4a0039d5&scoped=true"
import script from "./TabJob.vue?vue&type=script&lang=js"
export * from "./TabJob.vue?vue&type=script&lang=js"
import style0 from "./TabJob.vue?vue&type=style&index=0&id=4a0039d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0039d5",
  null
  
)

export default component.exports